import { authenticatedFetch } from './auth';

// lucia: ~~this is jank but good enough~~
// lucia: a better world is possible
const API_BASE = '/api/';

export const api = {

  async signup(formData: Record<string, any>) {
    const response = await fetch(`${API_BASE}signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      }
    );
    const data = await response.json();
    return data;
  },

  async signin(formData: Record<string, any>) {
    const response = await fetch(`${API_BASE}signin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      }
    );
    const data = await response.json();
    return data.token;
  },


  async getUser() {
    const response = await authenticatedFetch(`${API_BASE}info`);
    if (!response.ok) {
      throw new Error('Failed to fetch user info');
    }
    return response.json();
  },
  async getUserEntries() {
    const response = await authenticatedFetch(`${API_BASE}entries/mine`);
    if (!response.ok) {
      throw new Error('Failed to fetch user entries');
    }
    return response.json();
  },
  async getAllEntries() {
    const response = await authenticatedFetch(`${API_BASE}entries`);
    if (!response.ok) {
      throw new Error('Failed to fetch all entries');
    }
    return response.json();
  },

  async submitEntry(data: { link: string }) {
    const response = await authenticatedFetch(`${API_BASE}entry`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error('Failed to submit entry');
    }
    return response.json();
  },

  async getDeadline() {
    const response = await authenticatedFetch(`${API_BASE}deadline`);
    if (!response.ok) {
      throw new Error('Failed to fetch deadline');
    }
    return response.json();
  },

  async getSubmittedToday() {
    const response = await authenticatedFetch(`${API_BASE}today`);
    if (!response.ok) {
      throw new Error('Failed to fetch submitted today count');
    }
    return response.json();
  },

  async submitEarlySignup(email: string) {
    const response = await fetch(`${API_BASE}early-signup`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });
    if (!response.ok) {
      throw new Error('Failed to submit early signup');
    }
    return response.json();
  }
};
